<template>
  <collapse :active-index="0">
    <collapse-item body-classes="p-0 m-0">
      <template slot="title">
        <div class="row align-items-center">
          <div class="col-sm-4">
            <h3 class="mb-0">{{ title }}</h3>
          </div>

          <div class="col text-right mr-5">
            <slot name="actions"></slot>
          </div>
        </div>
      </template>

      <div v-if="dataIsLoaded" class="table-responsive">
        <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
          <el-table-column label="Distribuidor" min-width="145px" prop="distributor">
            <template #default="{ row }">
              <router-link
                v-if="$can('show', 'distributors')"
                :to="{
                  name: 'DistributorOrderList',
                  params: { id: row.distributor.id },
                  query: { campaign: campaign.id, variety: row.variety.id },
                }"
                class="h5"
              >
                {{ row.distributor.name }}
              </router-link>
              <span v-else class="h5">{{ row.distributor.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Campaña" min-width="145px" prop="campaign">
            <div v-if="campaign" class="font-weight-bold">{{ campaign.name }}</div>
          </el-table-column>

          <el-table-column label="Variedad" min-width="145px" prop="variety">
            <template #default="{ row }">
              <div>{{ row.variety.name }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Cantidad" min-width="145px" prop="quantity">
            <template #default="{ row }">
              <span>{{ row.quantity }}</span
              >&nbsp;
              <span class="font-weight-bold">({{ row.variety.crop.unit.toLowerCase() }})</span>
            </template>
          </el-table-column>

          <el-table-column label="Importe (USD)" min-width="145px" prop="amountUsd">
            <template #default="{ row }">
              <span>{{ row.amountUsd | toCurrencyUSD }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Importe (ARS)" min-width="145px" prop="amountUsd">
            <template #default="{ row }">
              <span>{{ row.amountArs | toCurrencyARS }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </collapse-item>
  </collapse>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'DistributorsSellsTable',
  components: {
    Collapse,
    CollapseItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [PaginationMixin],
  props: {
    title: {
      type: String,
      default: 'Totales por distribuidor',
    },

    campaignId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      searchKeys: [],
      results: [],
      campaign: null,
      dataIsLoaded: false,
    };
  },

  computed: {
    tableData() {
      return this.results;
    },
  },

  created() {
    this.pagination.perPage = 500;
    this.dataIsLoaded = false;
    this.fetchCampaign();
    this.fetchSells();
  },

  methods: {
    fetchSells() {
      this.$services
        .resource('orders_statistics')
        .sellsByDistributors(this.campaignId)
        .then((res) => res.data.data)
        .then((data) => {
          this.results = data.results;
          this.dataIsLoaded = true;
          this.sortByDistributor();
        });
    },

    fetchCampaign() {
      this.$services
        .resource('campaigns')
        .show(this.campaignId)
        .then((res) => res.data.data)
        .then((campaign) => (this.campaign = campaign));
    },

    sortByDistributor() {
      this.results.sort(this.compare_names);
    },

    compare_names(a, b) {
      if (a.distributor.name < b.distributor.name) {
        return -1;
      }
      if (a.distributor.name > b.distributor.name) {
        return 1;
      }
      return 0;
    },

    downloadPdf() {
      let filename = this.title.replaceAll(' ', '-').toLowerCase();
      this.$services.resource('orders_statistics').sellsByDistributorsPdf(this.campaignId, filename);
    },
  },
};
</script>
